import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const SewerTinderV2Guard = createFeatureGuard(Feature.SewerTinderV2);